import { render, staticRenderFns } from "./CustomersSettingIndex.vue?vue&type=template&id=6809e17a&scoped=true&"
import script from "./CustomersSettingIndex.vue?vue&type=script&lang=js&"
export * from "./CustomersSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./CustomersSettingIndex.vue?vue&type=style&index=0&id=6809e17a&prod&lang=scss&scoped=true&"
import style1 from "./CustomersSettingIndex.vue?vue&type=style&index=1&id=6809e17a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809e17a",
  null
  
)

export default component.exports